"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectCarouselFilmStrip = exports.default = void 0;

var _glamor = require("glamor");

var _reactFilm = require("react-film");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _remarkStripMarkdown = _interopRequireDefault(require("../Utils/remarkStripMarkdown"));

var _Bubble = _interopRequireDefault(require("./Bubble"));

var _connectToWebChat = _interopRequireDefault(require("../connectToWebChat"));

var _ScreenReaderText = _interopRequireDefault(require("../ScreenReaderText"));

var _textFormatToContentType = _interopRequireDefault(require("../Utils/textFormatToContentType"));

var _useAvatarForBot3 = _interopRequireDefault(require("../hooks/useAvatarForBot"));

var _useAvatarForUser3 = _interopRequireDefault(require("../hooks/useAvatarForUser"));

var _useDirection3 = _interopRequireDefault(require("../hooks/useDirection"));

var _useLocalizer = _interopRequireDefault(require("../hooks/useLocalizer"));

var _useRenderActivityStatus = _interopRequireDefault(require("../hooks/useRenderActivityStatus"));

var _useRenderAvatar = _interopRequireDefault(require("../hooks/useRenderAvatar"));

var _useStyleOptions3 = _interopRequireDefault(require("../hooks/useStyleOptions"));

var _useStyleSet3 = _interopRequireDefault(require("../hooks/useStyleSet"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ROOT_CSS = (0, _glamor.css)({
  display: 'flex',
  MsOverflowStyle: 'none',
  overflowX: 'scroll',
  overflowY: 'hidden',
  touchAction: 'manipulation',
  WebkitOverflowScrolling: 'touch',
  '&::-webkit-scrollbar': {
    display: 'none'
  },
  '& > .webchat__carouselFilmStrip__avatar': {
    flexShrink: 0
  },
  '& > .content': {
    flex: 1,
    '& > .message': {
      display: 'flex',
      '& > .bubble': {
        flexGrow: 1,
        overflow: 'hidden'
      },
      '& > .filler': {
        flexGrow: 10000,
        flexShrink: 1
      }
    },
    '& > ul': {
      display: 'flex',
      listStyleType: 'none',
      margin: 0,
      padding: 0,
      '& > li': {
        flex: 1
      }
    }
  }
});

var connectCarouselFilmStrip = function connectCarouselFilmStrip() {
  for (var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++) {
    selectors[_key] = arguments[_key];
  }

  return _connectToWebChat.default.apply(void 0, [function (_ref, _ref2) {
    var language = _ref.language,
        _ref$styleSet$options = _ref.styleSet.options,
        botAvatarInitials = _ref$styleSet$options.botAvatarInitials,
        userAvatarInitials = _ref$styleSet$options.userAvatarInitials;
    var _ref2$activity = _ref2.activity;
    _ref2$activity = _ref2$activity === void 0 ? {} : _ref2$activity;
    var _ref2$activity$from = _ref2$activity.from;
    _ref2$activity$from = _ref2$activity$from === void 0 ? {} : _ref2$activity$from;
    var role = _ref2$activity$from.role;
    return {
      avatarInitials: role === 'user' ? userAvatarInitials : botAvatarInitials,
      language: language
    };
  }].concat(selectors));
};

exports.connectCarouselFilmStrip = connectCarouselFilmStrip;

var WebChatCarouselFilmStrip = function WebChatCarouselFilmStrip(_ref3) {
  var activity = _ref3.activity,
      children = _ref3.children,
      className = _ref3.className,
      itemContainerRef = _ref3.itemContainerRef,
      nextVisibleActivity = _ref3.nextVisibleActivity,
      scrollableRef = _ref3.scrollableRef;

  var _useStyleOptions = (0, _useStyleOptions3.default)(),
      _useStyleOptions2 = _slicedToArray(_useStyleOptions, 1),
      _useStyleOptions2$ = _useStyleOptions2[0],
      bubbleNubSize = _useStyleOptions2$.bubbleNubSize,
      bubbleFromUserNubSize = _useStyleOptions2$.bubbleFromUserNubSize;

  var _useStyleSet = (0, _useStyleSet3.default)(),
      _useStyleSet2 = _slicedToArray(_useStyleSet, 1),
      carouselFilmStripStyleSet = _useStyleSet2[0].carouselFilmStrip;

  var _useAvatarForBot = (0, _useAvatarForBot3.default)(),
      _useAvatarForBot2 = _slicedToArray(_useAvatarForBot, 1),
      botInitials = _useAvatarForBot2[0].initials;

  var _useAvatarForUser = (0, _useAvatarForUser3.default)(),
      _useAvatarForUser2 = _slicedToArray(_useAvatarForUser, 1),
      userInitials = _useAvatarForUser2[0].initials;

  var _useDirection = (0, _useDirection3.default)(),
      _useDirection2 = _slicedToArray(_useDirection, 1),
      direction = _useDirection2[0];

  var localize = (0, _useLocalizer.default)();
  var renderActivityStatus = (0, _useRenderActivityStatus.default)({
    activity: activity,
    nextVisibleActivity: nextVisibleActivity
  });
  var renderAvatar = (0, _useRenderAvatar.default)({
    activity: activity
  });
  var _activity$attachments = activity.attachments,
      attachments = _activity$attachments === void 0 ? [] : _activity$attachments,
      _activity$channelData = activity.channelData;
  _activity$channelData = _activity$channelData === void 0 ? {} : _activity$channelData;
  var _activity$channelData2 = _activity$channelData.messageBack;
  _activity$channelData2 = _activity$channelData2 === void 0 ? {} : _activity$channelData2;
  var messageBackDisplayText = _activity$channelData2.displayText,
      _activity$from = activity.from;
  _activity$from = _activity$from === void 0 ? {} : _activity$from;
  var role = _activity$from.role,
      text = activity.text,
      textFormat = activity.textFormat;
  var fromUser = role === 'user';
  var activityDisplayText = messageBackDisplayText || text;
  var strippedActivityDisplayText = (0, _remarkStripMarkdown.default)(activityDisplayText);
  var indented = fromUser ? bubbleFromUserNubSize : bubbleNubSize;
  var initials = fromUser ? userInitials : botInitials;
  var roleLabel = localize(fromUser ? 'CAROUSEL_ATTACHMENTS_USER_ALT' : 'CAROUSEL_ATTACHMENTS_BOT_ALT');
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(ROOT_CSS + '', carouselFilmStripStyleSet + '', className + '', {
      webchat__carousel_indented_content: initials && !indented,
      webchat__carousel_extra_right_indent: !userInitials && bubbleFromUserNubSize
    }, direction === 'rtl' ? 'webchat__carousel--rtl' : ''),
    ref: scrollableRef
  }, renderAvatar && _react.default.createElement("div", {
    className: "webchat__carouselFilmStrip__avatar"
  }, renderAvatar()), _react.default.createElement("div", {
    className: "content"
  }, !!activityDisplayText && _react.default.createElement("div", {
    className: "message"
  }, _react.default.createElement(_ScreenReaderText.default, {
    text: roleLabel + ' ' + strippedActivityDisplayText
  }), _react.default.createElement(_Bubble.default, {
    "aria-hidden": true,
    className: "bubble",
    fromUser: fromUser,
    nub: true
  }, children({
    activity: activity,
    attachment: {
      content: activityDisplayText,
      contentType: (0, _textFormatToContentType.default)(textFormat)
    }
  })), _react.default.createElement("div", {
    className: "filler"
  })), _react.default.createElement("ul", {
    className: (0, _classnames.default)({
      webchat__carousel__item_indented: indented
    }),
    ref: itemContainerRef
  }, attachments.map(function (attachment, index) {
    return (// Because of differences in browser implementations, aria-label=" " is used to make the screen reader not repeat the same text multiple times in Chrome v75 and Edge 44
      _react.default.createElement("li", {
        "aria-label": " ",
        key: index
      }, _react.default.createElement(_ScreenReaderText.default, {
        text: roleLabel
      }), _react.default.createElement(_Bubble.default, {
        fromUser: fromUser,
        key: index,
        nub: false
      }, children({
        attachment: attachment
      })))
    );
  })), _react.default.createElement("div", {
    className: (0, _classnames.default)({
      webchat__carousel__item_indented: indented
    })
  }, renderActivityStatus())));
};

WebChatCarouselFilmStrip.defaultProps = {
  children: undefined,
  className: '',
  nextVisibleActivity: undefined
};
WebChatCarouselFilmStrip.propTypes = {
  activity: _propTypes.default.shape({
    attachments: _propTypes.default.array,
    channelData: _propTypes.default.shape({
      messageBack: _propTypes.default.shape({
        displayText: _propTypes.default.string
      }),
      state: _propTypes.default.string
    }),
    from: _propTypes.default.shape({
      role: _propTypes.default.string.isRequired
    }).isRequired,
    text: _propTypes.default.string,
    textFormat: _propTypes.default.string,
    timestamp: _propTypes.default.string
  }).isRequired,
  children: _propTypes.default.any,
  className: _propTypes.default.string,
  itemContainerRef: _propTypes.default.any.isRequired,
  nextVisibleActivity: _propTypes.default.shape({
    from: _propTypes.default.shape({
      role: _propTypes.default.string.isRequired
    }).isRequired,
    timestamp: _propTypes.default.string
  }),
  scrollableRef: _propTypes.default.any.isRequired
};

var CarouselFilmStrip = function CarouselFilmStrip(props) {
  return _react.default.createElement(_reactFilm.Context.Consumer, null, function (_ref4) {
    var itemContainerRef = _ref4.itemContainerRef,
        scrollableRef = _ref4.scrollableRef;
    return _react.default.createElement(WebChatCarouselFilmStrip, _extends({
      itemContainerRef: itemContainerRef,
      scrollableRef: scrollableRef
    }, props));
  });
};

var _default = CarouselFilmStrip;
exports.default = _default;